<template>
  <v-container fill-height style="max-width:100%;">
    <v-row style="height:100%;">
      <v-col style="height:100%;padding:0;">
        <v-card flat class="card-style">
          <div class="card-style-title">
            Vehicle free cycle routes
            <div class="btnCont">
              <iframe-modal :id="id" :src="src" :width="850" :height="700" />
              <v-btn
                depressed
                rounded
                color="#00486b"
                style="color:#fff"
                width="7em"
                :href="mapDatasetUrls"
                target="_blank"
              >
                Data
              </v-btn>
            </div>
          </div>
          <v-container v-if="!overlay" style="margin:10px;max-width:100%;">
            <v-row style="margin:10px 0;">
              <v-col cols="12" xs="12" sm="12" md="12">
                <div class="description">
                  <p>
                    Length in miles of cycle route that does
                    not have to be shared with vehicles (per 10,000 people)
                  </p>
                  <p class="source">
                    <span>
                      Data Source:
                      <a
                        target="_blank"
                        href="https://www.sustrans.org.uk/bike-life/">
                        Bike Life - Sustrans
                      </a>
                    </span>
                  </p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <HorizontalBarChart
                  :id="id"
                  :data="results"
                  :y-axis="yAxis"
                  :x-axis="xAxis"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import HorizontalBarChart from '@/components/horizontalBarChart.vue';
import iframeModal from '@/components/iframeModal.vue';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '../assets/css/material-design-iconic-font.min.css';

export default {
  components: {
    HorizontalBarChart,
    iframeModal,
  },
  data() {
    return {
      results: [],
      overlay: true,
      xAxis: { label: 'Route length per 10,000 people' },
      yAxis: { label: 'Location' },
      value: 0,
      id: 'cycleRouteInfo',
      src: 'cycleRouteInfo',
    };
  },
  computed: {
    ...mapGetters(['compositeDataset']),
    mapDatasetUrls() {
      let d = null;
      if (this.compositeDataset && this.compositeDataset.cycleRouteInformation) {
        d = this.compositeDataset.cycleRouteInformation.dataset;
        this.content(this.compositeDataset.cycleRouteInformation.apiResource);
      } else {
        console.error('No API Resource: ( cycleRouteInformation )');
      }
      return d;
    },
  },
  methods: {
    async content(resource) {
      const query = 'sort(-Route%20length%20per%2010%2C000%20people)';
      const params = { datasetGUID: resource, query };
      const newResults = await this.$store.dispatch('fetchData', params);
      this.results = newResults.data;
      this.overlay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-style {
  padding: 2em;
  width: 100%;
  height: 100%;
  justify-content: center;
}
.description {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  p {
    font-size: 1em;
    font-weight: bold;
  }
  .subtext {
    font-size: 0.8em;
  }
  .source {
    font-weight: bold;
    font-size: 0.8em;
    font-style: italic;
  }
}
@media (min-width: 650px) {
  .description {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    p {
      font-size: 1.2em;
      font-weight: bold;
    }
    .subtext {
      font-size: 1em;
    }
  }
}
</style>
